<script setup lang="ts">
import { computed, onMounted } from "vue";
import MainLayout from "@/layouts/MainLayout.vue";
import CalculatorLayout from "@/layouts/CalculatorLayout.vue";
import { useRoute } from "vue-router";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import { useUserStore } from "@/stores/userStore";

const layoutsMap: Record<string, object> = {
  main: MainLayout,
  calculator: CalculatorLayout,
  empty: EmptyLayout,
};

const route = useRoute();
const layoutComponent = computed(() => {
  const metaLayout: string =
    (route.meta.layout as string | undefined) ?? "main";

  return layoutsMap[metaLayout] ?? MainLayout;
});

const layoutProps = computed(() => ({
  withOverflow: route.meta.withOverflow,
  showBlogBtn: route.meta.showBlogBtn,
  showBgImage: route.meta.showBgImage,
}));

onMounted(async () => {
  const authStore = useUserStore();
  authStore.loadUserFromStorage();
  if (authStore.user !== null) {
    await authStore.updateUserInfo(true);
  }
});
</script>

<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <router-view v-slot="{ Component }">
      <KeepAlive include="ChineseCalendarView">
        <component :is="Component" :key="route.name" />
      </KeepAlive>
    </router-view>
  </component>
</template>

<style lang="scss">
#app {
  font-family: SF Pro Text, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
